/**
 * DevExtreme (esm/core/renderer.js)
 * Version: 21.2.8
 * Build date: Tue Jun 07 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import rendererBase from "./renderer_base";
export default rendererBase.get();
